export enum TransactionStatus {
  ERROR = 'error',
  SUCCESS = 'success',
  PROCESSING = 'processing',
}
